import styled from "styled-components";
import {TsrWithDropdownMainTextDefaultBox} from "./tsr-with-dropdown-main-text.default.box";

export const TsrWithDropdownMainTextCasino777Box = styled(TsrWithDropdownMainTextDefaultBox)`
  > span:nth-of-type(2) {
    color: ${props => props.theme.colors.brandPrimary};
  }
`